export const mediaConfigSchema = {
  type: 'object',
  properties: {
    voiceoverMarker: {
      type: 'object'
    }
  }
}
